"use strict";
import { clearStoredProjectFile, setStoredProjectFile } from "../utils/storage";
import {
    Grid,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Store } from "../Store";
import { getProjectById } from "../features/projects/api";
import {
    convertToDate,
    getLanguageName,
    getTaskNameFormal,
} from "../utils/generalFunctions";
import Loader from "../Components/Loader";
import { ToastContainer } from "react-toastify";
import GlobalButton from "../Components/Buttons/GlobalButton";
import { secondaryColor } from "../utils/constants";
import { workTypes } from "../Data/tasksCode";

const WorkPagesScreen = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { id: projectId } = params;
    const { state, dispatch: ctxDispatch } = useContext(Store);
    const { userInfo } = state;
    const [projectDetails, setProjectDetails] = useState([]);
    const [dataLoader, setDataLoader] = useState(true);

    const handleWork = (project, role, language) => {
        ctxDispatch({ type: "PROJECT_FILE", payload: project });
        setStoredProjectFile(project);

        if (role === "transcribe") navigate("/work/transcriber");
        else if (role === "translate") navigate(`/work/translator/${language}`);
        else if (role === "performancedirection")
            navigate(`/work/performancedirection/${language}`);
        else if (role === "performancedirectionversions")
            navigate(`/work/performancedirectionversions/${language}`);
        else if (role === "attribution")
            navigate(`/work/attribution`);
        else if (role === "lipqualityassurance")
            navigate(`/work/lipqualityassurance/${language}`);
        else if (role === "qualityassurance")
            navigate(`/work/qualityassurance/${language}`);
    };

    useEffect(() => {
        ctxDispatch({ type: "PROJECT_FILE_CLEAR" });
        clearStoredProjectFile();
    }, [ctxDispatch]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getProjectById(projectId);
                setProjectDetails(response.data);
                ctxDispatch({ type: "PROJECT_FILE", payload: response.data });
                setStoredProjectFile(response.data);
                setDataLoader(false);
            } catch (err) {
                console.error("Error fetching project details:", err);
                setDataLoader(false);
            }
        };

        fetchData();
    }, [projectId, ctxDispatch]);

    return (
        <Grid item container justifyContent="center">
            <Loader Load={dataLoader} use={userInfo} />
            <ToastContainer position="top-center" />
            <Grid
                item
                container
                xs={9.5}
                marginTop={7}
                direction="row"
                marginBottom={10}
            >
                <Grid
                    item
                    container
                    direction="row"
                    marginBottom={8.0}
                    justifyContent="flex-end"
                >
                    <Grid item>
                        <GlobalButton
                            onClick={() => {
                                ctxDispatch({
                                    type: "PROJECT_FILE",
                                    payload: projectDetails,
                                });
                                localStorage.setItem(
                                    "projectFile",
                                    JSON.stringify(projectDetails)
                                );
                                navigate(`/workpages/details/${projectId}`);
                            }}
                        >
                            Details
                        </GlobalButton>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead
              sx={{
                backgroundColor: secondaryColor,
                "& .MuiTableCell-root": { color: "var(--color-table-header-text)" },
              }}
            >
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>ACTIONS</TableCell>
                <TableCell>Original Language</TableCell>
                <TableCell>Final Languages</TableCell>
                <TableCell>Creation Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workTypes.map((type, index) => (
                <TableRow key={index}>
                  <TableCell>{getTaskNameFormal(type)}</TableCell>
                  <TableCell>
                    {type === "translate" ||
                      type === "performancedirection" ||
                      type === "performancedirectionversions" ||
                      type === "qualityassurance" ||
                      type === "lipqualityassurance" ? (
                      <Select
                        size="small"
                        color="primary"
                        defaultValue="Start Working"
                      >
                        <MenuItem value="Start Working">Start Working</MenuItem>
                        {projectDetails.finalLang?.map((language, index) => (
                          <MenuItem
                            key={index}
                            value={language}
                            onClick={() =>
                              handleWork(projectDetails, type, language)
                            }
                          >
                            {getLanguageName(language)}
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <GlobalButton
                        color="primary"
                        onClick={() => {
                          handleWork(projectDetails, type);
                        }}
                      >
                        Start Working
                      </GlobalButton>
                    )}
                  </TableCell>

                  <TableCell>
                    {getLanguageName(projectDetails.orginalLang)}
                  </TableCell>
                  <TableCell width="30%">
                    <Grid
                      item
                      container
                      direction="row"
                      gap={1}
                      alignItems="center"
                      justifyContent="center"
                    // bgcolor="red"
                    >
                      {projectDetails.finalLang?.map((language, index) => (
                        <Grid
                          xs={5.5}
                          item
                          container
                          key={index}
                          alignItems="center"
                          justifyContent="center"
                          width="300px"
                          height="32px"
                          sx={{
                            // background: `${secondaryColor}`,
                            background: "lightgrey",
                            fontWeight: "400",
                            borderRadius: "var(--radius-md)",
                          }}
                        >
                          <Grid item>{getLanguageName(language)}</Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </TableCell>
                  <TableCell>
                    {convertToDate(projectDetails.creationDate)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WorkPagesScreen;
